import create from '../creator'
import axios from '../../axios-setup'

const injectMagensa = commit => {
	const TEConnect = window['te-connect']
	const TEConnectJS = window['te-connect-js']

	if (TEConnect && TEConnectJS) {
		const tecPaymentRequest = {
			googleMerchantId: process.env.VUE_APP_GOOGLE_PAY_MAGENSA_MERCHANT_ID,
			appleMerchantId: process.env.VUE_APP_APPLE_PAY_MERCHANT_ID
		}
		const teInstance = TEConnect.createTEConnect(
			process.env.VUE_APP_MAGENSA_TECONNECT_KEY,
			{ tecPaymentRequest }
		)

		commit('mountMagensaPayment', new TEConnectJS.TeConnectJs(teInstance))
	}
}

const initialState = () => ({
	creditCards: [],
	magensaPaymentInstance: null,
	tecPrInterface: null
})
const state = initialState()

const actions = {
	async addCreditCard({ commit }, data) {
		const resp = await axios.post(`creditCard`, data)
		commit('addCreditCard', resp.data)
		return resp.data
	},

	async getCreditCards({ commit }) {
		const resp = await axios.get(`creditCard`)

		commit('setCreditCards', resp.data)
	},

	async validateExpDate({ commit }, payload) {
		const resp = await axios.post(
			'/creditCard/validateExpDate',
			payload,
			{},
			{ skipError: true }
		)

		commit('addCreditCard', resp.data)
	},

	setTecPrInterface({ commit }, data) {
		commit('setTecPrInterface', data)
	},

	mountTEconnect({ commit, state }) {
		if (state.magensaPaymentInstance) return

		const magensaCreateTEConnectScript = document.createElement('script')
		const magensaTeConnectJsScript = document.createElement('script')
		magensaCreateTEConnectScript.src =
			'https://cdn.magensa.net/te-connect/1.3.4/te-connect.js'
		magensaTeConnectJsScript.src =
			'https://cdn.magensa.net/te-connect-js/1.3.1/te-connect-js.js'
		magensaCreateTEConnectScript.onload = () => injectMagensa(commit)
		magensaTeConnectJsScript.onload = () => injectMagensa(commit)
		document.head.appendChild(magensaCreateTEConnectScript)
		document.head.appendChild(magensaTeConnectJsScript)
	}
}

const mutations = {
	mountMagensaPayment(state, data) {
		state.magensaPaymentInstance = data
	},

	setTecPrInterface(state, data) {
		state.tecPrInterface = data
	},

	addCreditCard(state, data) {
		// In this case all creditCards are default
		// state.creditCards = [...state.creditCards, data]
		state.creditCards = [data]
	},
	setCreditCards(state, data) {
		state.creditCards = [...data]
	}
}

const getters = {
	defaultCreditCard(state) {
		return state.creditCards.find(item => item.isDefault)
	},
	magensaPaymentInstance(state) {
		return state.magensaPaymentInstance
	},
	tecPrInterface(state) {
		return state.tecPrInterface
	}
}

export default create(
	{
		namespaced: true,
		state,
		actions,
		mutations,
		getters
	},
	initialState()
)
